module.exports = __webpack_public_path__ + "img/assignment-active.3b724710.svg";